// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap'
import Vue from 'vue'
import App from './App'
import Buefy from 'buefy'
import store from './store'
import Chart from 'chart.js'
import router from './router'
import 'buefy/dist/buefy.css'
import VModal from 'vue-js-modal'
import VeeValidate from 'vee-validate'
import VueChartkick from 'vue-chartkick'
import GlobalMixin from '@/mixins/Global'
import ValidationMessages from '@/lang/validation/en'

// Import the buefy styles
Vue.use(Buefy)
Vue.use(VeeValidate)
Vue.use(VueChartkick, {adapter: Chart})
Vue.use(VModal, { componentName: 'base-modal' })

Vue.mixin(GlobalMixin)
Vue.config.productionTip = false
VeeValidate.Validator.localize('en', ValidationMessages)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js